export default __webpack_public_path__ + "static/media/total-rent.18d93139.svg";